import React, {Component} from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
/**
 * BSD License
 * For the rebound-js software
 * Copyright (c) 2014, Facebook, Inc. All rights reserved.
 * @link https://github.com/facebook/rebound-js
 */
import {SpringSystem, MathUtil} from 'rebound';

export default class ScrollBarsAnimate extends Component {
    constructor(props) {
        super(props);
        this.handleSpringUpdate = this.handleSpringUpdate.bind(this);
        this.scrollbarRef = React.createRef();
    }

    componentDidMount() {
        this.springSystem = new SpringSystem();
        this.spring = this.springSystem.createSpring();
        this.spring.addListener({onSpringUpdate: this.handleSpringUpdate});
    }

    componentWillUnmount() {
        this.springSystem.deregisterSpring(this.spring);
        this.springSystem.removeAllListeners();
        this.springSystem = undefined;
        this.spring.destroy();
        this.spring = undefined;
    }

    // 현재 스크롤 위치
    getScrollTop() {
        return this.scrollbarRef.current.getScrollTop();
    }

    // 전체 스크롤 높이
    getScrollHeight() {
        return this.scrollbarRef.current.getScrollHeight();
    }

    // 창의 높이
    getClientHeight() {
        return this.scrollbarRef.current.getClientHeight();
    }

    scrollTop(top) {
        const scrollTop = this.scrollbarRef.current.getScrollTop();
        // const scrollHeight = this.scrollbarRef.current.getScrollHeight();
        // const val = MathUtil.mapValueInRange(
        //   top,
        //   0,
        //   scrollHeight,
        //   scrollHeight * 0.2,
        //   scrollHeight * 0.8,
        // );
        this.spring.setCurrentValue(scrollTop).setAtRest();
        this.spring.setEndValue(top);
    }

    handleSpringUpdate(spring) {
        const val = spring.getCurrentValue();
        this.scrollbarRef.current.scrollTop(val);
    }

    render() {
        return <Scrollbars {...this.props} ref={this.scrollbarRef}/>;
    }
}
